import { useEffect, useRef } from "react";
import { useParcels } from "../../context/ParcelContext";
import ParcelsTable from "./ParcelsTable";
import { registerParcelsExcelListener } from "../../utils/registerParcelsExcelListener";

export default function ParcelsPage() {
  const { parcels } = useParcels();
  const parcelsRef = useRef(parcels);

  // const TEMP_PIN = "1990";

  // keep ref in sync
  useEffect(() => {
    parcelsRef.current = parcels;
  }, [parcels]);

  useEffect(() => {
    const unregister = registerParcelsExcelListener(
      () => parcelsRef.current
    );

    return unregister;
  }, []);

  // const initialAuthed = useMemo(
  //   () => sessionStorage.getItem("parcels_pin_authed") === "true",
  //   []
  // );

  // const [isAuthed, setIsAuthed] = useState(initialAuthed);
  // const [pinInput, setPinInput] = useState("");
  // const [pinError, setPinError] = useState("");

  // const handleSubmitPin = (e: React.FormEvent) => {
  //   e.preventDefault();

  //   if (pinInput === TEMP_PIN) {
  //     sessionStorage.setItem("parcels_pin_authed", "true");
  //     setIsAuthed(true);
  //     setPinError("");
  //     setPinInput("");
  //     return;
  //   }

  //   setPinError("Incorrect PIN.");
  // };

  return (
    <div className="min-h-screen bg-[#F4F6F9]">
      {/* Temporary Password Form */}
      {/* {!isAuthed && (
        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/30 px-4 pt-6">
          <div className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-4 shadow-xl">
            <div className="mb-2 flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#21506F]">
                <svg
                  className="h-4 w-4 text-white"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M12 15v2m-6 4h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1V9a5 5 0 1 0-10 0v2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div>
                <h2 className="text-sm font-semibold text-slate-900">
                  Enter PIN
                </h2>
                <p className="text-xs text-slate-500">
                  Temporary access for the parcels page
                </p>
              </div>
            </div>

            <form onSubmit={handleSubmitPin} className="mt-3 space-y-3">
              <input
                type="password"
                inputMode="numeric"
                value={pinInput}
                onChange={(e) => {
                  setPinInput(e.target.value);
                  if (pinError) setPinError("");
                }}
                placeholder="Enter PIN"
                className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none ring-0 placeholder:text-slate-400 focus:border-[#21506F]"
                autoFocus
              />

              {pinError && (
                <p className="text-xs text-red-600">{pinError}</p>
              )}

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="inline-flex items-center rounded-lg bg-[#21506F] px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-[#15314d]"
                >
                  Continue
                </button>
              </div>
            </form>
          </div>
        </div>
      )} */}


      <ParcelsTable />
    </div>
  );
}
